<template>
	<div class="loginBody">
		<!-- <img src="../assets/logo.png"/> -->
		<div class="loginDiv">
			<div class="login-content">
				<!-- <img src="../../public/logo.png" style="width: 300px;height: 95px;margin-left: 50px;" /> -->
				<h1 class="login-title" style="margin-top: 20px;">网站后台管理系统</h1>
				<h2 class="login-title">用户登录</h2>
				<el-form :model="loginForm" label-width="100px" :rules="rules" ref="loginForm"
					style="margin-left: -5px;">
					<el-form-item label="账号" prop="account">
						<el-col :span="20">
							<el-input style="" type="text" v-model="loginForm.account" autocomplete="off" size="small">
							</el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="密码" prop="password">
						<el-col :span="20">
							<el-input style="" type="password" v-model="loginForm.password" autocomplete="off"
								size="small" show-password @keyup.enter.native="confirm"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item style="padding-top: 20px;">
						<!-- 	<el-button type="primary" style="width: 70%;margin-right: 10%;" @click="confirm"
							:disabled="confirm_disabled">登录</el-button> -->
						<el-button type="primary" style="width: 70%;margin-right: 10%;" @click="confirm">登录</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "Login",
		data() {
			return {
				confirm_disabled: false,
				loginForm: {
					account: '',
					password: ''
				},
				rules: {
					account: [{
						required: true,
						message: '请输入正确的账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入正确的密码',
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			confirm() {
				let that = this;
				this.confirm_disabled = true;
				this.$refs.loginForm.validate((valid) => {
					if (valid) {
						this.utils.requestPost(this, "/user/login", that.loginForm, function(res, total) {
							that.confirm_disabled = false;
							that.utils.showMessage("success", "登录成功");
							sessionStorage.setItem('CurUser', JSON.stringify(res.user));
							that.$store.commit("setMenu", res.menu)
							that.$router.replace('/index');
						}, function() {
							that.confirm_disabled = false;
							// that.confirm_disabled = false;
							that.utils.showMessage("error", "网络异常");
						});
					} else {
						this.confirm_disabled = false;
						that.utils.showMessage("error", "账号或密码错误");
					}
				})
			}
		}
	}
</script>

<style scoped>
	.loginBody {
		position: absolute;
		width: 100%;
		height: 100%;
		background: #B3C0D1;
		/* background-image: url(../assets/dxbg.jpg); */
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		height: 100%;
		background-attachment: fixed;
	}

	.loginDiv {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -200px;
		margin-left: -250px;
		width: 450px;
		height: 400px;
		background: #fff;
		border-radius: 5%;
	}

	.login-title {
		margin-bottom: 20px;
		text-align: center;
	}

	.login-content {
		width: 400px;
		height: 400px;
		position: absolute;
		top: 25px;
		margin-left: 25px;
	}
</style>